import { render, staticRenderFns } from "./step.vue?vue&type=template&id=5dbf1178&scoped=true"
import script from "./step.vue?vue&type=script&lang=ts"
export * from "./step.vue?vue&type=script&lang=ts"
import style0 from "./step.vue?vue&type=style&index=0&id=5dbf1178&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dbf1178",
  null
  
)

export default component.exports